import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './UploadAvatar.css'; // Your custom styles

import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';


function Publications() {
    const [showMenu, setShowMenu] = useState(false);
    const [scrolling, setScrolling] = useState(false);

    const toggleMenu = () => {
        setShowMenu(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
       
            

            <NRDRUHSHeader />

            <Helmet>
                <link rel="canonical" href="https://nrdruh.in/publications" />
                <meta name="robots" content="noindex, follow" />
            </Helmet>

       {/* ISSN Content */}
       <div className="row" style={{ marginTop: 60, marginBottom: 180, justifyContent: 'center', textAlign: 'center' }}>
        <h1>Publications</h1>
                <div style={{ marginBottom: '20px' }}>
                    <button
                        style={{
                            backgroundColor: '#ff2056',
                            color: 'white',
                            padding: '30px 60px',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            borderRadius: '6px',
                            margin: '10px',
                            cursor: 'pointer',
                            border: 'none', // <-- This removes the border
                        }}
                        onClick={() => window.open('https://nrdruhs.in/uploads/National%20Research%20Denticon%20Vol%2013%20Issue%20No%201%20Oct-Dec%202024.html', '_blank')}
                    >
                        Vol 13 Issue No 4 Oct-Dec 2024
                    </button>
                </div>
                
            </div>






            <NRDRUHSFooter />
        </div>
    );
}

export default Publications;
